export const generateOnIconPress = ({onOrderPress}: any, orderId: any) => {
  return () => {
    onOrderPress({orderId: orderId});
  };
};
